import AdminPage from "./main.container";

export default AdminPage;
